import 'mapbox-gl/dist/mapbox-gl.css';

import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import DefaultLayout from './layouts/DefaultLayout';
import SearchChatbotPage from 'pages/chatbot/SearchChatbotPage';
import ListingChatbotPage from 'pages/chatbot/ListingChatbotPage';
import SearchedProperties from 'pages/html/SearchedProperties';
import Elements from 'pages/html/Elements';
import SingleCard from 'pages/html/richcontent/SingleCard';
import MultipleProperties from 'pages/html/richcontent/MultipleProperties';
import AllCards from 'pages/html/richcontent/AllCards';
import PropertyOverlay from 'pages/html/PropertyOverlay';
import PropertyChat from 'pages/html/richcontent/PropertyChat';
import FiltersOverlay from 'pages/html/FiltersOverlay';
import { PageNotFound404 } from 'pages/public/PageNotFound404';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from 'components/ErrorBoundary';

const router = createBrowserRouter([
  {
    path: "/",
    element: <DefaultLayout />,
    children: [
      {
        index: true,
        element: <SearchChatbotPage />
      },
      {
        path: "share/:token",
        element: <SearchChatbotPage />
      },
      {
        path: ":session",
        element: <SearchChatbotPage />
      },
      {
        // Backend entry point: the SPA boots here with the question injected in
        // the #server-input <script> tag. Redirect to "/" (replace) so the chat
        // runs from the General Assistant root, where new-session navigation
        // resolves correctly (relative "./<id>" -> "/<id>"). The injected
        // question survives the redirect (module-scoped) and is consumed at "/".
        // Must precede the dynamic listing/:harid route so "search" isn't
        // captured as a harid.
        path: "listing/search",
        element: <Navigate to="/" replace />
      },
      {
        path: "listing/:harid/share/:token",
        element: <ListingChatbotPage />
      },
      {
        path: "listing/:harid/:session?",
        element: <ListingChatbotPage />
      },
      {
        path: "html/SearchedProperties",
        element: <SearchedProperties />
      },
      {
        path: "html/Elements",
        element: <Elements />
      },
      {
        path: "html/FiltersOverlay",
        element: <FiltersOverlay />
      },
      {
        path: "html/PropertyOverlay",
        element: <PropertyOverlay />
      },
      {
        path: "html/richcontent/SingleCard",
        element: <SingleCard />
      },
      {
        path: "html/richcontent/MultipleProperties",
        element: <MultipleProperties />
      },
      {
        path: "html/richcontent/AllCards",
        element: <AllCards />
      },
      {
        path: "html/richcontent/PropertyChat",
        element: <PropertyChat />
      },
      {
        path: "*",
        element: <PageNotFound404 />
      }
    ]
  }
], {
  basename: process.env.PUBLIC_URL
});

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
